import acerca from "./component/acercaDe/acerca";
// import Inicio from "./component/inicio/Inicio";
import Inicio2 from "./component/inicio/Inicio2";
// import Reporteador from "./component/reporteador/Reporteador";
import Reportes from "./component/reportes/Reportes";

const rutas = [
  // {path: '/Reporteador2', componente: Reporteador},
  { path: "/Reporteador/:tipo", componente: Reportes},
  { path: "/Inicio", componente: Inicio2 },
  { path: "/AcercaDe", componente: acerca },
  { path: "*", componente: Inicio2 },
];

export default rutas;
